import { combineReducers} from 'redux'

import calculator from './calculator'


export default combineReducers({
    calculator
})